import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { AssessementComponent } from '../components/assessement/assessement.component';

@Injectable({ providedIn: 'root' })
export class GeogebraOpenerService {
  public readonly geogebraDialogId = 'geogebra-assessment-dialog';

  private dialog = inject(MatDialog);

  openExercise(data: string | object, context: object): MatDialogRef<AssessementComponent> {
    if (!data) {
      console.warn('Cannot open geogebra exercise without data');
      return;
    }

    if (this.dialog.getDialogById(this.geogebraDialogId)) {
      console.warn('A geogebra exercise is already open. Close the existing dialog first.');
      return;
    }

    return this.dialog.open(AssessementComponent, {
      data: {
        data,
        context,
      },
      panelClass: 'ui-geogebra--fullscreen',
      id: this.geogebraDialogId,
    });
  }
}
